import React from "react"
import { categoryLabel, clubLabel, competitionsLabel, daysLabel, stateLabel } from "./plannerLabels"
import { openWarnings } from "./plannerItems"

// A tournament on the calendar (ticket 15 Q3): the state owns the fill and the border, the category only the dot.

// "Needs a new confirmation", "Changed after it was sent": what a proposal the organizer must see again says (Phase C2a marks).
export const sendingMark = item => (item.marks?.needsNewConfirmation ? "Needs a new confirmation"
  : item.marks?.changedAfterSent?.length ? "Changed after it was sent" : null)
// What a card or a chip says to a screen reader and in its tooltip: number, category, club, days, state, then its marks. A published
// event has no warnings (the read gives it none).
export const itemTitle = (item, settings) => {
  const warnings = openWarnings(item).length
  return [item.label, categoryLabel(settings, item.category), clubLabel(item.club, ", "), daysLabel(item.days), stateLabel(item.state), sendingMark(item),
    warnings && `${warnings} ${warnings === 1 ? "warning" : "warnings"}`, item.needsFees && "No fees", item.cancelled && "Cancelled"].filter(Boolean).join(" · ")
}

// The Month card: line 1 the city and the club, and the open warnings; line 2 the state, the number and the competitions. Compact:
// the dot, the city and the number. A published event without fees says so (B3 pinned decision Q7).
export default function PlannerCard({ item, settings, compact }) {
  const warnings = openWarnings(item).length
  const city = item.club?.city || clubLabel(item.club)
  const number = item.kind === "event" ? `#${item.eventId}` : item.number
  const marks = <>
    {sendingMark(item) && <i className="bx bx-revision ep-card-flag" aria-hidden="true" />}
    {warnings > 0 && <span className="ep-card-warn" aria-hidden="true"><i className="bx bx-error" />{warnings}</span>}
    {item.needsFees && <span className="ep-mark ep-mark-error">No fees</span>}
  </>
  if (compact) {
    return <span className="ep-card-body is-compact" title={itemTitle(item, settings)}>
      <span className={`ep-dot ep-cat-${item.category}`} aria-hidden="true" /><span className="ep-trunc">{city}</span>
      <span className="ep-card-number">{number}</span>{marks}
    </span>
  }
  return <span className="ep-card-body" title={itemTitle(item, settings)}>
    <span className="ep-card-line">
      <span className={`ep-dot ep-cat-${item.category}`} aria-hidden="true" />
      <span className="ep-trunc">{item.club?.kind === "club" ? `${item.club.city} · ${item.club.clubName}` : clubLabel(item.club)}</span>
      {marks}
    </span>
    <span className="ep-card-line">
      <span className={`ep-state ep-state-${item.state}`}>{stateLabel(item.state)}</span>
      <span className="ep-card-number">{number}</span>
      <span className="ep-trunc ep-tiles">{competitionsLabel(item.competitions)}</span>
    </span>
  </span>
}
